import { FC } from 'react';

const Meh: FC<{ filled?: boolean }> = ({ filled }) => {
    const color = filled ? '#F57C00' : '#BDBDBD';

    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1438_5179)">
                <path
                    d="M24.9588 50C11.2026 50 0 38.7974 0 24.9588C0 11.2026 11.2026 0 24.9588 0C38.715 0 49.9176 11.2026 49.9176 24.9588C50 38.7974 38.7974 50 24.9588 50ZM24.9588 3.29489C13.0148 3.29489 3.29489 13.0148 3.29489 24.9588C3.29489 36.9028 13.0148 46.6227 24.9588 46.6227C36.9028 46.6227 46.6227 36.9028 46.6227 24.9588C46.7051 13.0148 36.9852 3.29489 24.9588 3.29489Z"
                    fill={color}
                />
                <path
                    d="M16.3098 22.9819C17.902 22.9819 19.1928 21.6911 19.1928 20.0989C19.1928 18.5066 17.902 17.2158 16.3098 17.2158C14.7175 17.2158 13.4268 18.5066 13.4268 20.0989C13.4268 21.6911 14.7175 22.9819 16.3098 22.9819Z"
                    fill={color}
                />
                <path
                    d="M33.3606 22.9819C34.9528 22.9819 36.2436 21.6911 36.2436 20.0989C36.2436 18.5066 34.9528 17.2158 33.3606 17.2158C31.7683 17.2158 30.4775 18.5066 30.4775 20.0989C30.4775 21.6911 31.7683 22.9819 33.3606 22.9819Z"
                    fill={color}
                />
                <path
                    d="M33.9561 34.5963C33.9561 34.5963 28.5302 33.9886 25.1423 34.5963C21.5846 35.2345 17.3169 38.303 17.3169 38.303C16.4108 38.303 15.6694 37.5616 15.6694 36.6555C15.6694 35.7495 16.4747 35.0082 17.2984 34.5963C17.2984 34.5963 21.3308 31.9694 24.7304 31.3014C28.2656 30.6068 33.9561 31.3014 33.9561 31.3014C34.8622 31.3014 35.6035 32.0428 35.6035 32.9489C35.6035 33.8549 34.8622 34.5963 33.9561 34.5963Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1438_5179">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Meh;
